import { Container } from '@amelio/ui-library';
import { Trans } from 'react-i18next';

import { FeatureItem } from '@/components/FeatureItem/FeatureItem';
import { CreateSurveyTemplateArrowIllustration } from '@/components/Illustrations/Illustration';
import { useAmelioTranslations } from '@/hooks';

export const TemplateHeader = () => {
    const { t } = useAmelioTranslations();
    return (
        <Container direction={'row'}>
            <FeatureItem
                weight={'semibold'}
                className={'max-w-xl flex-row gap-6 p-6 sm:max-h-40'}
                heading={t('templateManagement.template.header.manageYourTemplate')}
                description={
                    <Trans
                        i18nKey={'templateManagement.template.header.templateAccesible'}
                        components={{ bold: <b /> }}
                    />
                }
            />

            <CreateSurveyTemplateArrowIllustration
                className={'relative top-25 -left-15 z-2 hidden max-h-40 scale-120 sm:!block'}
            />
        </Container>
    );
};
